const ExteriorVR = () => {
    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-exterior/Exterior/PUBLISH%202/index.htm`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="Exterior VR Tour"
        ></iframe>
      </div>
    );
};

export default ExteriorVR;
